import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "isDark"];
import cn from "classnames";
import { Skeleton } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SimpleCourseCardSkeleton = function SimpleCourseCardSkeleton(_ref) {
  var className = _ref.className,
    isDark = _ref.isDark,
    simpleCourseCardSkeletonProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: cn('flex flex-col rounded-5 overflow-hidden', isDark ? 'bg-base-lighter-24' : 'bg-white shadow-1-dp', className)
  }, simpleCourseCardSkeletonProps), {}, {
    children: [/*#__PURE__*/_jsx(Skeleton, {
      isDark: isDark,
      className: "h-160 rounded-t-5"
    }), /*#__PURE__*/_jsxs("section", {
      className: cn('p-16', {
        'bg-base-main': isDark
      }),
      children: [/*#__PURE__*/_jsx(Skeleton, {
        isDark: isDark,
        className: "h-40"
      }), /*#__PURE__*/_jsx(Skeleton, {
        isDark: isDark,
        className: "h-20 mt-8 w-1/2"
      }), /*#__PURE__*/_jsx(Skeleton, {
        isDark: isDark,
        className: "h-40 mt-24 rounded-5"
      })]
    })]
  }));
};
export default SimpleCourseCardSkeleton;